/* INTEGY V252 — iPhone-only mobile filters + product/cart layout guard — 15JUN2026
   Does not run on desktop. */
(function(){
  'use strict';
  if(window.INTEGY_V252_MOBILE_ONLY_LOADED) return;
  window.INTEGY_V252_MOBILE_ONLY_LOADED = true;

  function isMobile(){
    try { return (window.matchMedia && window.matchMedia('(max-width: 860px)').matches) || /iPhone|iPod|Android/i.test(navigator.userAgent || ''); }
    catch(e){ return /iPhone|iPod|Android/i.test(navigator.userAgent || ''); }
  }
  if(!isMobile()) return;

  var docEl = document.documentElement;
  docEl.classList.add('integy-v252-mobile-only');

  var currentScript = document.currentScript;
  var assetBase = '';
  try { assetBase = (currentScript && currentScript.src ? currentScript.src : '').replace(/[^\/]+(?:\?.*)?$/, ''); } catch(e) {}
  if(!assetBase) assetBase = window.INTEGY_FILTER_INDEX_ASSET_BASE || '/cdn/shop/t/0/assets/';

  var indexCache = Object.create(null);
  var productCache = null;
  var productPromise = null;

  var TITLE_FILTER_COLLECTIONS = {
    'cars-trucks': 1,
    '1-10-and-1-12-rc-vehicles': 1,
    '1-18-and-1-24-rc-vehicles': 1,
    '1-14-1-18-1-24-off-road-rtr-parts': 1,
    'all-terrain-off-road-vehicles': 1
  };
  var TITLE_MODES = [
    {key:'rtr', label:'RTR', re:/\bRTR\b/i},
    {key:'artr', label:'ARTR', re:/\bARTR\b/i},
    {key:'kit', label:'Kit', re:/\bKIT\b/i}
  ];

  var HANDLE_ALIASES = {
    'all-integy-hop-up-parts': 'all',
    'parts-for-arrma': 'hopups-for-arrma',
    'hop-up-parts-for-arrma': 'hopups-for-arrma',
    'parts-for-traxxas': 'hop-up-parts-for-traxxas',
    'hopups-for-traxxas': 'hop-up-parts-for-traxxas',
    'parts-for-associated': 'hopups-for-associated',
    'hop-up-parts-for-associated': 'hopups-for-associated',
    'parts-for-axial-adventure': 'hopups-for-axial',
    'parts-for-axial': 'hopups-for-axial',
    'parts-for-losi': 'hopups-for-losi',
    'hop-up-parts-for-losi': 'hopups-for-losi',
    'parts-for-tamiya': 'hopups-for-tamiya',
    'hop-up-parts-for-tamiya': 'hopups-for-tamiya',
    'parts-for-hpi-racing': 'hop-up-parts-for-hpi-racing'
  };

  var COLORS = {
    black:1, blue:1, red:1, green:1, silver:1, grey:1, gray:1, gunmetal:1, orange:1,
    purple:1, pink:1, yellow:1, gold:1, white:1, clear:1, smoke:1, brown:1, bronze:1, chrome:1
  };

  var PART_PRIORITY = [
    'wheel','tire','wheel-hex','wheel-nut','hub-carrier','steering-block','caster-block',
    'shock','shock-tower','spring','suspension','suspension-arm','linkage','link','turnbuckle','rod-end','ball-end',
    'drive-shaft','shaft','axle','gear','pinion-gear','spur-gear','gearbox','bearing',
    'bumper','skid-plate','chassis','body','rc-body','body-mount','body-post','mount',
    'servo','servo-horn','motor','motor-mount','esc','cooling-fan','fan','heatsink','radio','receiver','battery','charger','connector','plug','wire','led-light',
    'tool','wrench','hex-wrench','nut-driver','driver','tool-set','setup-tool','setup-station','workstation',
    'rock-crawler','drift','touring','1-5','1-6','1-7','1-8','1-10','1-12','1-14','1-16','1-18','1-24','1-28','1-36',
    'black','blue','red','green','silver','grey','gray','gunmetal','orange','purple','gold','yellow','white','clear'
  ];
  var PRIORITY = Object.create(null);
  PART_PRIORITY.forEach(function(k,i){PRIORITY[k]=i+1;});

  var VEHICLE_BRANDS = {
    'hopups-for-arrma':1,'hop-up-parts-for-traxxas':1,'hopups-for-losi':1,'hopups-for-axial':1,
    'hopups-for-associated':1,'hop-up-parts-for-hpi-racing':1,'hopups-for-tamiya':1,'hop-up-parts-for-kyosho':1,
    'hopups-for-element':1,'hopups-for-redcat':1,'hopups-for-vanquish':1
  };

  var ELECTRONICS_ALLOWED = {
    'motor':1,'esc':1,'cooling-fan':1,'fan':1,'heatsink':1,'battery':1,'radio':1,'receiver':1,'charger':1,'connector':1,'plug':1,'wire':1,'gyro':1,'servo':1,'power-supply':1,'discharger':1,
    'black':1,'blue':1,'red':1,'green':1,'silver':1,'grey':1,'gray':1,'gunmetal':1,'orange':1,'purple':1,'gold':1,'yellow':1,'white':1,'1-10':1,'1-8':1,'1-18':1,'1-24':1
  };

  var VEHICLE_ELECTRIC_NOISE = {'esc':1,'gyro':1,'receiver':1,'radio':1,'battery':1,'charger':1,'connector':1,'plug':1,'wire':1,'power-supply':1,'discharger':1};

  function qs(s,r){try{return (r||document).querySelector(s)}catch(e){return null}}
  function qsa(s,r){try{return Array.prototype.slice.call((r||document).querySelectorAll(s))}catch(e){return[]}}
  function clean(s){return String(s == null ? '' : s).replace(/\s+/g,' ').trim()}
  function esc(s){return String(s == null ? '' : s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function handleize(v){
    v=String(v||'').toLowerCase();
    try{v=v.normalize('NFKD').replace(/[\u0300-\u036f]/g,'')}catch(e){}
    return v.replace(/&/g,' and ').replace(/[’']/g,'').replace(/[^a-z0-9]+/g,'-').replace(/-+/g,'-').replace(/^-|-$/g,'');
  }
  function labelize(h){
    var special={rc:'RC',esc:'ESC',led:'LED',hpi:'HPI',rtr:'RTR',artr:'ARTR',kit:'Kit',dbxl:'DBXL',xmaxx:'X-Maxx','1':'1'};
    if(/^1-\d+/.test(h)) return h.replace(/-/g,'/').replace(/\/(\d+)(?:\/|$)/, function(m){return m;});
    return String(h||'').split('-').filter(Boolean).map(function(w){return special[w] || w.charAt(0).toUpperCase()+w.slice(1)}).join(' ')
      .replace(/\bRc\b/g,'RC').replace(/\bEsc\b/g,'ESC').replace(/\bHpi\b/g,'HPI').replace(/\bLed\b/g,'LED');
  }
  function parts(){return (location.pathname||'').split('/').filter(Boolean)}
  function currentHandle(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?handleize(decodeURIComponent(p[i+1])):''}
  function indexHandle(){var h=currentHandle();return HANDLE_ALIASES[h] || h}
  function basePath(){var p=parts(),i=p.indexOf('collections');return i>=0&&p[i+1]?'/'+p.slice(0,i+2).join('/'):''}
  function activeTags(){
    var p=parts(), i=p.indexOf('collections'), out=[];
    if(i<0 || !p[i+2] || p[i+2]==='products') return out;
    decodeURIComponent(p[i+2]).split('+').forEach(function(t){t=handleize(t); if(t) out.push(t);});
    return out;
  }
  function activeVehicleMode(){try{return handleize(new URLSearchParams(location.search||'').get('integy_vehicle_filter')||'')}catch(e){return''}}
  function productCount(){
    var main=qs('main')||document.body;
    var txt=clean(main ? main.textContent : '');
    var m=txt.match(/(?:^|\s)([\d,]+)\s+products?(?:\s|$)/i);
    return m ? (parseInt(m[1].replace(/,/g,''),10)||0) : 0;
  }
  function urlFor(tag,active){
    var p=basePath(), tags=activeTags().filter(function(t){return t && t!==tag});
    if(!active) tags.push(tag);
    var u=new URL(p + (tags.length?'/'+tags.join('+'):''), location.origin);
    try{
      var cur=new URLSearchParams(location.search||'');
      ['page','view','grid_list','sort_by','integy_vehicle_filter'].forEach(function(k){cur.delete(k)});
      cur.forEach(function(v,k){if(v!=null&&v!=='')u.searchParams.set(k,v)});
    }catch(e){}
    return u.pathname + (u.search ? u.search : '');
  }
  function vehicleModeUrl(key){
    var u=new URL(basePath(), location.origin);
    try{
      var cur=new URLSearchParams(location.search||'');
      ['page','view','grid_list','integy_vehicle_filter'].forEach(function(k){cur.delete(k)});
      cur.forEach(function(v,k){if(v!=null&&v!=='')u.searchParams.set(k,v)});
    }catch(e){}
    if(key) u.searchParams.set('integy_vehicle_filter', key);
    return u.pathname + (u.search ? u.search : '');
  }
  function formatCount(n){n=Number(n||0);return '('+n.toLocaleString()+')'}
  function intersectCount(a,b){
    if(!a||!b) return 0;
    var s=Object.create(null), c=0;
    for(var i=0;i<a.length;i++) s[a[i]]=1;
    for(var j=0;j<b.length;j++) if(s[b[j]]) c++;
    return c;
  }
  function intersectArrays(a,b){
    if(!a) return (b||[]).slice();
    if(!b) return [];
    var s=Object.create(null), out=[];
    for(var i=0;i<a.length;i++) s[a[i]]=1;
    for(var j=0;j<b.length;j++) if(s[b[j]]) out.push(b[j]);
    return out;
  }

  function closePanels(){
    qsa('.integy-v252-mobile-backdrop,.integy-v252-mobile-filter-panel,.integy-v221-backdrop,.integy-v221-panel').forEach(function(el){try{el.remove()}catch(e){}});
    try{document.body.style.overflow=''}catch(e){}
  }
  function makePanel(title, subtitle){
    closePanels();
    var b=document.createElement('div');
    var p=document.createElement('div');
    b.className='integy-v252-mobile-backdrop';
    p.className='integy-v252-mobile-filter-panel';
    p.innerHTML='<div class="integy-v252-mobile-filter-head"><h2>'+esc(title || 'Filter parts')+'</h2><button class="integy-v252-mobile-filter-close" type="button" aria-label="Close">×</button></div><div class="integy-v252-mobile-filter-body"><p class="integy-v252-mobile-filter-subtitle">'+esc(subtitle || 'Use filters to narrow this collection.')+'</p><div class="integy-v252-mobile-filter-status">Loading filters…</div></div>';
    document.body.appendChild(b); document.body.appendChild(p);
    try{document.body.style.overflow='hidden'}catch(e){}
    b.addEventListener('click',closePanels,{passive:true});
    qs('.integy-v252-mobile-filter-close',p).addEventListener('click',closePanels,{passive:true});
    return qs('.integy-v252-mobile-filter-body',p);
  }

  function indexUrl(h){return assetBase + 'integy-filter-index-' + encodeURIComponent(h) + '.json'}
  function loadIndex(h){
    h=HANDLE_ALIASES[h] || h;
    if(!h) return Promise.resolve(null);
    if(indexCache[h]) return Promise.resolve(indexCache[h]);
    return fetch(indexUrl(h), {credentials:'same-origin', cache:'force-cache'}).then(function(r){return r.ok?r.json():null}).then(function(data){indexCache[h]=data; return data;}).catch(function(){return null});
  }

  function rowAllowed(handle, tag, label, active){
    if(!tag || tag==='clearance') return false;
    if(active) return true;
    if(handle==='rc-electronics' && !ELECTRONICS_ALLOWED[tag]) return false;
    if(handle==='boats') {
      var boatAllowed = {'rc-boat':1,'motor':1,'esc':1,'shaft':1,'servo':1,'mount':1,'battery':1,'radio':1,'connector':1,'plug':1,'wire':1,'charger':1,'box':1,'red':1,'black':1,'blue':1,'silver':1,'orange':1,'yellow':1,'gunmetal':1,'white':1};
      if(!boatAllowed[tag]) return false;
    }
    if(VEHICLE_BRANDS[handle] && VEHICLE_ELECTRIC_NOISE[tag]) return false;
    if(PRIORITY[tag]) return true;
    if(COLORS[tag]) return true;
    return false;
  }

  function rowsFromIndex(data){
    if(!data || !data.tags) return [];
    var tags=data.tags||{}, labels=data.labels||{}, active=activeTags(), handle=indexHandle();
    var activeSet=null;
    active.forEach(function(t){ if(tags[t]) activeSet = intersectArrays(activeSet, tags[t]); });
    var total=productCount();
    var out=[];
    Object.keys(tags).forEach(function(tag){
      var arr=tags[tag]; if(!arr || !arr.length) return;
      var isActive=active.indexOf(tag)!==-1;
      var c=activeSet && activeSet.length ? (isActive ? activeSet.length : intersectCount(activeSet, arr)) : arr.length;
      if(!c) return;
      if(total && c>total) c=total;
      var label=labels[tag] || labelize(tag);
      if(!rowAllowed(handle, tag, label, isActive)) return;
      out.push({tag:tag,label:label,count:c,active:isActive,href:urlFor(tag,isActive),rank:PRIORITY[tag] || 999});
    });
    out.sort(function(a,b){
      if(a.active!==b.active) return a.active?-1:1;
      if(a.rank!==b.rank) return a.rank-b.rank;
      if(b.count!==a.count) return b.count-a.count;
      return a.label.localeCompare(b.label);
    });
    return out.slice(0,80);
  }

  function renderRows(body, rows, opts){
    opts=opts||{};
    var activeRows=rows.filter(function(r){return r.active});
    var html='';
    if(activeRows.length){
      html+='<div class="integy-v252-mobile-active"><span class="integy-v252-mobile-active-title">Active filters</span><div class="integy-v252-mobile-active-pills">';
      activeRows.forEach(function(r){html+='<a class="integy-v252-mobile-pill" href="'+esc(r.href)+'">'+esc(r.label)+' ×</a>';});
      html+='</div><a class="integy-v252-mobile-clear" href="'+esc(opts.clearUrl || basePath())+'">Clear all filters</a></div>';
    }
    if(opts.groupTitle) html+='<span class="integy-v252-mobile-group-title">'+esc(opts.groupTitle)+'</span>';
    html+='<input class="integy-v252-mobile-search" type="search" autocomplete="off" placeholder="Find filters…">';
    html+='<div class="integy-v252-mobile-filter-list">';
    rows.forEach(function(r){
      html+='<a class="integy-v252-mobile-filter-row'+(r.active?' is-active':'')+'" href="'+esc(r.href)+'" data-filter-label="'+esc((r.label+' '+r.tag).toLowerCase())+'"><span>'+esc(r.label)+(r.active?' ×':'')+'</span><span class="integy-v252-mobile-filter-count">'+(typeof r.count==='number'?formatCount(r.count):'')+'</span></a>';
    });
    html+='</div>';
    body.innerHTML=html;
    var input=qs('.integy-v252-mobile-search',body);
    if(input){
      input.addEventListener('input',function(){
        var q=clean(input.value).toLowerCase();
        qsa('.integy-v252-mobile-filter-row',body).forEach(function(a){
          a.hidden = !!(q && (a.getAttribute('data-filter-label')||'').indexOf(q)<0);
        });
      },{passive:true});
    }
  }

  function collectSidebarRows(){
    var sb=qs('.productgrid--sidebar,[data-productgrid-sidebar]');
    if(!sb) return [];
    var seen=Object.create(null), rows=[];
    qsa('a[href*="/collections/"]', sb).forEach(function(a){
      if(a.closest('[data-integy-v250-active-box],.integy-v27-active-filter-box')) return;
      var txt=clean(a.textContent||'');
      if(!txt || /clear all|active filters|refine results/i.test(txt)) return;
      var countMatch=txt.match(/\(([\d,]+)\)\s*$/);
      var count=countMatch ? parseInt(countMatch[1].replace(/,/g,''),10) : 0;
      var labelEl=qs('.integy-v201-filter-label,.integy-v200-filter-label,.integy-filter-label',a);
      var label=clean(labelEl ? labelEl.textContent : txt.replace(/\([\d,]+\)\s*$/,''));
      var tag=handleize(label);
      if(!label || !a.href || seen[a.href]) return;
      seen[a.href]=1;
      var total=productCount(); if(total && count>total) count=total;
      rows.push({tag:tag,label:label,count:count,active:/is-active|active|checked/.test(a.className||'') || a.getAttribute('aria-checked')==='true',href:a.getAttribute('href')||a.href,rank:PRIORITY[tag]||999});
    });
    rows.sort(function(a,b){if(a.active!==b.active)return a.active?-1:1;if(a.rank!==b.rank)return a.rank-b.rank;if(b.count!==a.count)return b.count-a.count;return a.label.localeCompare(b.label)});
    return rows.slice(0,80);
  }

  function cardsIn(doc){return qsa('[data-productgrid-items] .productgrid--item,.productgrid--items .productgrid--item', doc)}
  function cardTitle(card){var t=qs('.productitem--title',card);return clean((t||card).textContent||'')}
  function cardUrl(card){var a=qs('.productitem--title a,[data-product-page-link],a[href*="/products/"]',card);return a?String(a.getAttribute('href')||''):''}
  function maxPage(){
    var max=1; qsa('a[href*="page="]').forEach(function(a){try{var u=new URL(a.href,location.origin),n=parseInt(u.searchParams.get('page')||'',10);if(n>max)max=n}catch(e){}});
    if(max<2){var total=productCount(), per=cardsIn(document).length||24; if(total&&per) max=Math.max(max, Math.ceil(total/per));}
    return Math.min(Math.max(max,1),12);
  }
  function pageUrl(n){
    var u=new URL(basePath(), location.origin);
    try{var cur=new URLSearchParams(location.search||''); ['page','view','grid_list','integy_vehicle_filter'].forEach(function(k){cur.delete(k)}); cur.forEach(function(v,k){if(v!=null&&v!=='')u.searchParams.set(k,v)});}catch(e){}
    if(n>1) u.searchParams.set('page',String(n));
    return u.toString();
  }
  function fetchPage(n){if(n===1) return Promise.resolve(document.documentElement.outerHTML); return fetch(pageUrl(n),{credentials:'same-origin',cache:'force-cache',headers:{Accept:'text/html'}}).then(function(r){return r.ok?r.text():''}).catch(function(){return''});}
  function collectProducts(){
    if(productCache) return Promise.resolve(productCache);
    if(productPromise) return productPromise;
    var pages=[]; for(var i=1,n=maxPage();i<=n;i++) pages.push(i);
    productPromise=Promise.all(pages.map(fetchPage)).then(function(htmls){
      var parser=new DOMParser(), seen=Object.create(null), out=[];
      htmls.forEach(function(html){if(!html)return; var doc=parser.parseFromString(html,'text/html'); cardsIn(doc).forEach(function(card){var url=cardUrl(card),title=cardTitle(card),key=url||title;if(!key||seen[key])return;seen[key]=1;out.push({title:title,url:url});});});
      productCache=out; return out;
    }).catch(function(){productCache=cardsIn(document).map(function(card){return{title:cardTitle(card),url:cardUrl(card)}}); return productCache;});
    return productPromise;
  }
  function renderVehicleTitleFilters(body){
    var active=activeVehicleMode();
    body.innerHTML='<p class="integy-v252-mobile-filter-subtitle">Loading vehicle type filters…</p><div class="integy-v252-mobile-filter-status">Checking product titles for RTR, ARTR, and Kit…</div>';
    collectProducts().then(function(items){
      var counts={rtr:0,artr:0,kit:0};
      (items||[]).forEach(function(item){TITLE_MODES.forEach(function(m){if(m.re.test(item.title||''))counts[m.key]++;});});
      var rows=[];
      TITLE_MODES.forEach(function(m){ if(counts[m.key]) rows.push({tag:m.key,label:m.label,count:counts[m.key],active:active===m.key,href:vehicleModeUrl(active===m.key?'':m.key),rank:PRIORITY[m.key]||100}); });
      if(!rows.length) body.innerHTML='<div class="integy-v252-mobile-filter-status">No RTR, ARTR, or Kit labels were found in this collection.</div>';
      else renderRows(body,rows,{groupTitle:'Vehicle Type',clearUrl:basePath()});
    });
  }

  function openFilter(){
    var ch=currentHandle();
    var body=makePanel('Filter parts', TITLE_FILTER_COLLECTIONS[ch] ? 'Use Vehicle Type to narrow this vehicle collection.' : 'Use the same static collection filters as desktop.');
    if(TITLE_FILTER_COLLECTIONS[ch]) { renderVehicleTitleFilters(body); return; }

    setTimeout(function(){
      var sideRows=collectSidebarRows();
      if(sideRows.length){ renderRows(body,sideRows,{groupTitle:'More Part Filters',clearUrl:basePath()}); return; }
      loadIndex(indexHandle()).then(function(data){
        var rows=rowsFromIndex(data);
        if(!rows.length){body.innerHTML='<div class="integy-v252-mobile-filter-status">No additional filters are available for this collection.</div>';return;}
        renderRows(body,rows,{groupTitle:'More Part Filters',clearUrl:basePath()});
      });
    },80);
  }

  function isCollection(){return document.body && (document.body.classList.contains('template-collection') || document.body.classList.contains('template-search'))}
  function filterButtonFromEvent(e){
    var t=e.target;
    if(!t || !t.closest) return null;
    return t.closest('.integy-v221-filter-trigger,[data-productgrid-trigger-filters],.utils-filter-button,.productgrid--utils-filter-button');
  }
  function intercept(e){
    if(!isCollection()) return;
    var b=filterButtonFromEvent(e);
    if(!b) return;
    e.preventDefault(); e.stopPropagation(); if(e.stopImmediatePropagation) e.stopImmediatePropagation();
    openFilter();
    return false;
  }
  window.addEventListener('click',intercept,true);
  window.addEventListener('touchend',intercept,{capture:true,passive:false});

  function patchLabels(){
    qsa('.integy-v221-head h2').forEach(function(h){ if(/filter pats/i.test(h.textContent||'')) h.textContent='Filter parts'; });
  }

  function patchAtcBanner(){
    var banner=qs('[data-atc-banner],.atc-banner--container');
    if(!banner) return;
    qsa('.atc--product-details--title,[data-atc-banner-product-title],.atc-banner--product-title',banner).forEach(function(el){
      el.style.writingMode='horizontal-tb';
      el.style.textOrientation='mixed';
      el.style.whiteSpace='normal';
      el.style.wordBreak='normal';
      el.style.overflowWrap='anywhere';
    });
  }

  function boot(){ patchLabels(); patchAtcBanner(); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot,{once:true}); else boot();
  window.addEventListener('pageshow',function(){setTimeout(boot,60)},{passive:true});
  window.addEventListener('load',function(){[100,500,1200,2400].forEach(function(ms){setTimeout(boot,ms);});},{passive:true});
  try{new MutationObserver(function(){patchLabels();patchAtcBanner();}).observe(document.body||document.documentElement,{childList:true,subtree:true,characterData:true});}catch(e){}
})();
